import { render, staticRenderFns } from "./AcceleratorArticle.vue?vue&type=template&id=14b7e21c&"
import script from "./AcceleratorArticle.vue?vue&type=script&lang=js&"
export * from "./AcceleratorArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports